import { render, staticRenderFns } from "./ButtonSpec.vue?vue&type=template&id=f19a985c&scoped=true"
import script from "./ButtonSpec.vue?vue&type=script&lang=js"
export * from "./ButtonSpec.vue?vue&type=script&lang=js"
import style0 from "./ButtonSpec.vue?vue&type=style&index=0&id=f19a985c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19a985c",
  null
  
)

export default component.exports